import { render, staticRenderFns } from "./PassOfferToJobModal.vue?vue&type=template&id=140b276f&"
import script from "./PassOfferToJobModal.vue?vue&type=script&lang=js&"
export * from "./PassOfferToJobModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports